import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import * as messageConstants from '../../../shared/messages';
import { CopyToClipboard } from "react-copy-to-clipboard";
import "./ClientCredentials.scss"

class ClientCredentials extends Component {

  static propTypes = {
    clientId: PropTypes.string,
  };

  state = {
    copiedClientId: false,
  };
  handleCopyTextClear = (event) => {
    const textItem = event.currentTarget.id;
    const copied = {};
    copied[textItem] = false;
    this.setState(copied);
  };

  handleCopyText = (event) => {
    const textItem = event.currentTarget.id;
    const copied = {};
    copied[textItem] = true;
    this.setState(copied);
  };

  render() {
    const { clientId } = this.props;
    return (
      <div className="oidc-credentials-container">
        <p className="sba-subtitle">
          {messageConstants.OIDC_CLIENT_CREDENTIALS}
        </p>
        {clientId ? (
          <div>
            <label className="oidc-credentials-label-title">{messageConstants.OIDC_CLIENT_ID}</label>
            <div className="copy-row">
              <div className="oidc-credentials-entry-value"
                   id="clientIdValue">
                  {clientId}
              </div>
              <div className="copy-link">
                <CopyToClipboard text={clientId}>
                  {
                    this.state.copiedClientId ? (
                      <input id="copiedClientId"
                             onClick={this.handleCopyTextClear}
                             type="button"
                             value={messageConstants.COPIED}
                             className="button_check"/>
                    ) : (
                      <button title={messageConstants.COPY}
                              id="copiedClientId"
                              className="btn btn-link"
                              onClick={this.handleCopyText}>
                        <i className="copy-mark"/>
                      </button>
                    )
                  }
                </CopyToClipboard>
              </div>
            </div>
          </div>
        ) : null }
      </div>
    );
  };
}

export default ClientCredentials;
